<app-container class="defer-container flex flex-col"
               ngClass.lt-md="xs"
               [ngStyle.lt-md]="{ 'overflow-y': 'hidden' }"
               [noTopPadding]="handsetService.isMobile"
               [noPadding]="handsetService.isMobile"
               [sidePadding]="'0'">
  <div class="defer-bordered-container">
    <ng-container *ngIf="!loaded">
      <div class="content-center auto-margin" style="min-height: 100px;">
        <app-new-spinner></app-new-spinner>
      </div>
    </ng-container>

    <ng-container *ngIf="(websocketStatus$ | async) === 1 && data$ | async as model">
      <div *ngIf="loaded;">
        <div fxLayout="row" fxLayout.xs="column-reverse" fxLayoutAlign="center center"
             fxLayoutGap="0" class="search-button" [ngStyle]="{'padding': model.hasLiabilities ? null : 0}">
          <div *ngIf="model.hasLiabilities" class="search-container"
               ngClass.lt-md="xs" fxFlex="0 1 960px"
               fxFlex.lt-md="1 1 100%"
               fxLayout="row" fxLayoutAlign="start center">
            <div class="search flex items-center">
              <app-icon name="search" class="icon-search"></app-icon>
              <label for="searchInput" class="cdk-visually-hidden">Wyszukaj wydatku</label>
              <input id="searchInput"
                     fxFlex
                     [formControl]="input"
                     [placeholder]="'Wyszukaj wydatek'"
                     [appInputMaxLength]="100" />
              <button mat-icon-button
                      aria-label="Wyczyść"
                      (click)="clearSearch()"
                      [disabled]="loadingService.loading$ | async">
                <span class="cdk-visually-hidden">Wyczyść</span>
                <app-icon name="close"></app-icon>
              </button>
            </div>
          </div>
          <div class="filter" *ngIf="model.hasLiabilities">

            <app-new-loader-button *ngIf="cartAmountToPay !==undefined"
                                   [customType]="LoaderButtonType.RAISED"
                                   color="accent"
                                   class="medium-button"
                                   (buttonClick)="addLiabilitiesToCart()">
              Odrocz wybrane {{ cartAmountToPay | paykaCurrency }}
            </app-new-loader-button>
          </div>
        </div>


        <ng-container *ngIf="model.hasLiabilities">
          <div style="table-layout: fixed;"
               [ngStyle.lt-md]="{
            'overflow-y': 'auto',
            'overflow-x': 'hidden',
            'width': '100%',
            'height': 'calc( clamp(calc(100vh - 60px), 100dvh, 100vh) - 170px)'
            }">
            <div class="table-header">
              <ng-container *ngIf="handsetService.isNotMobile">
                <div class="filter-group text-center">
                  <div class="filter filter-padding ">
                    <button (click)="onAllSelected()" aria-label="Wybierz wszystkie"
                            class="button-as-text" [ngClass]="{'selected': this.selectedFilter === null}">
                      Wszystkie
                    </button>
                  </div>
                  <div *ngFor="let item of statusFilters" class="filter filter-padding">
                    <button (click)="onStatusSelected(item)"
                            class="button-as-text"
                            [attr.aria-label]="'Filtruj' + item.name"
                            [ngClass]="{'selected': item === this.selectedFilter}">
                      <div>
                        {{ item.filterDescription }}
                      </div>
                    </button>
                  </div>
                </div>
              </ng-container>
              <!--          </div>-->
              <mat-header-cell *matHeaderCellDef>
              </mat-header-cell>
              <app-table
                [isExpandable]="false"
                [isFloatingMenu]="true"
                [showDetails]="true"
                [data]="getLiabilities()"
                [columns]="columns"
                [isSelectable]="true"
                [rowStyle]="rowStyle"
                [rowMobileStyle]="rowStyle"
                (addedSelection)="onCheckList($event, true)"
                (removedSelection)="onCheckList($event, false)"
                (rowOnclick)="showDetails($event)"
                [showInformation]="true">
                <ng-container mobileFilters *ngIf="handsetService.isMobile">
                  <div class="filter-container">
                    <div class="filter">
                      <button [attr.aria-label]="'Wybierz wszystkie'"
                              (click)="this.onAllSelected()" class="button-as-text" [ngClass]="{
                              'selected': this.selectedFilter === null}">
                        Wszystkie
                      </button>
                    </div>
                    <div *ngFor="let item of statusFilters" class="filter">
                      <button [attr.aria-label]="'Filtruj' + item.name"
                              (click)="onStatusSelected(item)" class="button-as-text" [ngClass]="{
                              'selected': item === this.selectedFilter}">
                        <div>{{ item.filterDescription }}</div>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </app-table>
              <div *ngIf="!model.hasMorePast || selectedFilter"
                   style="height: 1rem">

              </div>
              <div *ngIf="model.hasMorePast && !selectedFilter"
                   class="load-more flex flex-row items-center justify-center">
                <button
                  *ngIf="!loadingPastLiabilities; else pastSpinner"
                  mat-raised-button
                  color="accent"
                  class="small-button load-more-btn"
                  (click)="loadMorePastWithLoader()">
                  Pokaż starsze
                </button>
                <ng-template #pastSpinner>
                  <mat-spinner [diameter]="24"></mat-spinner>
                </ng-template>
              </div>
              <ng-container *ngIf="model.liabilities.length === 0">
                <div class="empty-search">
                  <p style="margin:0">Brak wyników wyszukiwania</p>
                </div>
              </ng-container>
            </div>
          </div>

        </ng-container>
        <ng-container *ngIf="!model.hasLiabilities">
          <div class="empty-list-padding" fxLayout="column" ngClass.xs="xs">
            <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
              <img alt="loader" src="/assets/icons/payka-loader.svg" (load)="onImageLoad()" />
              <h1 *ngIf="imageLoaded" class="header"
                  style="font-size: 1.5rem; padding-bottom: 1rem; font-weight: bold; margin-top: 1rem">
                Zyskaj spokój
              </h1>
            </div>
            <p *ngIf="imageLoaded" class="text-center" style="font-size: 12px">
              Dodaj swoje wydatki, będziesz mógł odraczać je w prosty sposób.
            </p>
            <div class="flex flex-col" style="align-self: center; margin-top: 32px">
              <app-new-loader-button
                *ngIf="imageLoaded"
                class="big-button button-250 self-center"
                color="accent"
                t [customType]="LoaderButtonType.RAISED"
                [routerLink]="'/liabilities/add'"
                cdkFocusInitial
                buttonType="submit">Dodaj wydatek
              </app-new-loader-button>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>

  </div>

  <ng-template #loading>
    <app-loading></app-loading>
  </ng-template>
</app-container>

<router-outlet></router-outlet>
